module.exports = __webpack_public_path__ + "static/media/2DGACM12.2b07ce2b.jpg";